module.exports = __webpack_public_path__ + "static/WEDDING E&M-28-b60d816c9c507eca36c17c199e54fc27.jpg";